import React from 'react';
import styled from 'styled-components';
import { neutral } from '../../../style/colors';
import LokalplanListItem, { PureLokalplanListItem } from './LokalplanListItem';
import { MapboxGeoJSONFeature } from 'mapbox-gl';
const LokalplanList = (props: ILokalplanListPropType) => {
  const {
    planer,
    title,
    accentColor,
    bgColor,
    onListItemClick,
    onListItemHover,
    hoveredPlans,
    pureComponent,
  } = props;
  if (!planer.length) {
    return null;
  }
  const keys = new Set();
  const uniquePlaner = planer
    .filter(plan => {
      const { planid } = plan.properties;
      if (keys.has(planid)) {
        return false;
      }
      keys.add(planid);
      return true;
    })
    .sort((a, b) => {
      return a.properties.delnr > b.properties.delnr ? 1 : -1;
    });
  const listItems = uniquePlaner.map((plan, index) => {
    plan.properties.index = index;
    return pureComponent ? (
      <PureLokalplanListItem
        key={plan.properties.planid}
        accentColor={accentColor}
        bgColor={bgColor}
        feature={plan}
        onClick={onListItemClick}
        onHover={onListItemHover}
        isHovered={
          hoveredPlans.findIndex(p => p === plan.properties.planid) > -1
        }
        othersAreHovered={hoveredPlans.length > 0 && hoveredPlans[0] > -1}
        clickedByggefelt={0}
        clickedDelomraade={0}
      />
    ) : (
      <LokalplanListItem
        key={plan.properties.planid}
        accentColor={accentColor}
        bgColor={bgColor}
        feature={plan}
        onClick={onListItemClick}
        onHover={onListItemHover}
        isHovered={
          hoveredPlans.findIndex(p => p === plan.properties.planid) > -1
        }
        othersAreHovered={hoveredPlans.length > 0 && hoveredPlans[0] > -1}
      />
    );
  });

  return (
    <Wrapper>
      <h2>{title}</h2>
      <ListItemWrapper>{listItems}</ListItemWrapper>
    </Wrapper>
  );
};

interface ILokalplanListPropType {
  title: string;
  accentColor: string;
  bgColor: string;
  planer: Array<MapboxGeoJSONFeature>;
  onListItemClick?: Function;
  onListItemHover?: Function;
  hoveredPlans: Array<number>;
  pureComponent?: boolean;
}

export default LokalplanList;

const Wrapper = styled.div`
  padding: 30px 32px 15px 32px;
  border-top: 1px solid ${neutral[200]};
`;
const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
